import { jsxs as h, jsx as v } from "react/jsx-runtime";
import { forwardRef as x } from "react";
import g from "clsx";
import { SvgIconRoot as S } from "./svg-icon.styles.js";
import { useUtilityClasses as w } from "./svg-icon.classes.js";
import { useThemeProps as I } from "@mui/system";
const y = x(
  function(c, n) {
    const e = I({ props: c, name: "TrueSvgIcon" }), {
      children: l,
      className: m,
      color: a = "inherit",
      fontSize: f = "medium",
      htmlColor: p,
      inheritViewBox: r = !1,
      titleAccess: o,
      viewBox: s = "0 0 24 24",
      ...d
    } = e, t = {
      ...e,
      color: a,
      fontSize: f,
      inheritViewBox: r,
      viewBox: s
    }, i = {};
    r || (i.viewBox = s);
    const u = w(t);
    return /* @__PURE__ */ h(
      S,
      {
        as: "svg",
        className: g(u.root, m),
        ownerState: t,
        focusable: "false",
        color: p,
        "aria-hidden": o ? void 0 : !0,
        role: o ? "img" : void 0,
        ref: n,
        ...i,
        ...d,
        children: [
          l,
          o ? /* @__PURE__ */ v("title", { children: o }) : null
        ]
      }
    );
  }
);
export {
  y as default
};
//# sourceMappingURL=svg-icon.component.js.map
